<!-- <div class="container mt-5">
  <h2 class="mb-4">Explore New Project by Localities</h2>

  <div class="locality-tabs-container">
    <button
      *ngFor="let city of cityData"
      class="locality-btn"
      [ngClass]="{ active: searchWhereActual.city === city.city_name }"
      (click)="selectCity(city)"
    >
      {{ city.city_name }}
    </button>
  </div>

  <hr class="mb-4" />

  <h3 *ngIf="searchWhereActual.city" class="mb-3">
    Localities in {{ searchWhereActual.city }}
  </h3>

  <div class="row project-listings mt-4">
    <ng-container *ngIf="landmarkCountRecords.length > 0">
      <div
        *ngFor="let landmark of landmarkCountRecords | slice : 1"
        class="col-lg-2 col-md-3 col-sm-4 col-6 mb-2"
      >
        <a
          class="project-link"
          [routerLink]="['/properties/city/', searchWhereActual.city]"
          [queryParams]="{
            landmark: landmark['PropertyToMasterLandmarkData.landmark_name']
          }"
        >
          {{ landmark["PropertyToMasterLandmarkData.landmark_name"] }}
        </a>
      </div>
    </ng-container>
  </div>

  <div
    *ngIf="landmarkCountRecords.length === 0"
    class="mt-5 text-center text-muted"
  >
    No landmarks found in {{ searchWhereActual.city }}.
  </div>
  <div *ngIf="searchWhereActual.city" class="mt-4">
    <h4 class="mb-3">Properties for sale in {{ searchWhereActual.city }}</h4>

    <hr />

    <div class="row">
      <div class="col-md-4">
        <h5 class="mt-3 mb-2 section-heading">Popular Categories Searches</h5>

        <ul class="category-list">
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ property_type_id: '1' }"
            >
              Apartments in {{ searchWhereActual.city }}
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ property_type_id: '2' }"
            >
              Villas in {{ searchWhereActual.city }}
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ property_type_id: '3' }"
            >
              Townhouses in {{ searchWhereActual.city }}
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ property_type_id: '4' }"
            >
              Pent House Properties in {{ searchWhereActual.city }}
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ property_type_id: '5' }"
            >
              Others Properties in {{ searchWhereActual.city }}
            </a>
          </li>
        </ul>
      </div>
      <div class="col-md-4">
        <h5 class="mt-3 mb-2 section-heading">
          Popular Budget Searches (Sale)
        </h5>

        <ul class="category-list">
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ min_price: 0, max_price: 500000 }"
            >
              Properties below 500k AED
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ min_price: 500000, max_price: 1000000 }"
            >
              Properties from 500k to 1M AED
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ min_price: 1000000, max_price: 2000000 }"
            >
              Properties from 1M to 2M AED
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{ min_price: 2000000 }"
            >
              Properties Above 2M AED
            </a>
          </li>
          <li>
            <a
              class="link-color"
              [routerLink]="['/properties/city/', searchWhereActual.city]"
              [queryParams]="{
                property_type_id: '1',
                min_price: 0,
                max_price: 800000
              }"
            >
              Apartments below 800k AED
            </a>
          </li>
        </ul>
      </div>

      <div class="col-md-4" *ngIf="developerData?.length">
        <h5 class="mt-3 mb-2 section-heading">Popular Developers Searches</h5>

        <ul class="category-list">
          <li *ngFor="let developer of developerData | slice : 0 : 5">
            <a
              class="link-color"
              [routerLink]="['/developer-view/', developer.developer_id]"
              [queryParams]="{ city_id: searchWhereActual.city_id }"
            >
              {{ developer.developer_name }}
            </a>
          </li>

          <li *ngIf="developerData.length > 5">
            <a [routerLink]="['/developers/city/', searchWhereActual.city]">
              View All Developers
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div> -->
<footer class="ftco-footer">
  <div class="container-xl">
    <div class="row mb-5 pb-5">
      <div class="col-md-6 col-lg-3">
        <div class="ftco-footer-widget">
          <div class="logo-area">
            <h2 class="ftco-heading-2 logo d-flex">
              <a class="navbar-brand align-items-center" href="">
                <img
                  src="https://d3om06iw6o6an5.cloudfront.net/logo/direkt-logo-black-full.png"
                  class="footer_logo"
                />
              </a>
              </h2>
              </div>
              <p class="footer-description">
                Direkt.ae is a tech-driven real estate platform connecting developers directly with buyers, eliminating brokerage. It
                offers transparent listings, verified projects, and marketing solutions to boost visibility and sales. With a focus on
                trust and innovation, Direkt.ae simplifies property discovery and empowers smarter decisions in the UAE real estate
                market.
              </p>
              </div>
              </div>

      <div class="col-md-6 col-lg-2">
        <div class="ftco-footer-widget mb-4">
          <h2 class="ftco-heading-2 footer-heading">Quick Link</h2>
          <ul class="list-unstyled footer-links">
            <li>
              <a href=""
                ><span class="fa fa-chevron-right link-arrow"></span>Home</a
              >
            </li>
            <li>
              <a href="/about"
                ><span class="fa fa-chevron-right link-arrow"></span>About Us</a
              >
            </li>
            <li>
              <a href="/careers"
                ><span class="fa fa-chevron-right link-arrow"></span>Career</a
              >
            </li>
            <li>
              <a href="javascript:void(0)"
                ><span class="fa fa-chevron-right link-arrow"></span>Blogs</a
              >
            </li>
            <li>
              <a href="/faq"
                ><span class="fa fa-chevron-right link-arrow"></span>FAQs</a
              >
            </li>
            <li>
              <a href="/contact"
                ><span class="fa fa-chevron-right link-arrow"></span>Contact</a
              >
            </li>
            <li>
              <a href="/privacy-policy"
                ><span class="fa fa-chevron-right link-arrow"></span>Privacy
                Policy</a
              >
            </li>
            <li>
              <a href="/terms-of-use"
                ><span class="fa fa-chevron-right link-arrow"></span
                >Agreement</a
              >
            </li>
            <li>
              <a href="/disclaimers"
                ><span class="fa fa-chevron-right link-arrow"></span
                >Disclaimer</a
              >
            </li>
          </ul>
        </div>
      </div>

      <div class="col-md-6 col-lg-2">
        <div class="ftco-footer-widget mb-4">
          <h2 class="ftco-heading-2 footer-heading">Trending Category</h2>
          <ul class="list-unstyled footer-links">
            <li>
              <a [routerLink]="['/properties/no_of_bedrooms', 2]">2 BHK</a>
            </li>
            <li>
              <a [routerLink]="['/properties/no_of_bedrooms', 3]">3 BHK</a>
            </li>
            <li>
            <a [routerLink]="['/properties/no_of_bedrooms', 0]">Studio</a>
            </li>
          </ul>
          <!-- <ul class="list-unstyled footer-links">
            <li><a href="javascript:void(0)">The Regal</a></li>
            <li><a href="javascript:void(0)">Satatya Synl-2</a></li>
            <li><a href="javascript:void(0)">Indraprasth Shivanta</a></li>
            <li><a href="javascript:void(0)">The Gold By Samor</a></li>
            <li><a href="javascript:void(0)">Venus Pashmina</a></li>
            <li><a href="javascript:void(0)">Kavisha The Portrait</a></li>
            <li><a href="javascript:void(0)">Ayaan</a></li>
          </ul> -->
        </div>
      </div>

      <div class="col-md-6 col-lg-2">
        <div class="ftco-footer-widget mb-4">
          <h2 class="ftco-heading-2 footer-heading">Popular Searches</h2>
          <ul class="list-unstyled footer-links">
            <li>
              <a href="properties/city/Abu Dhabi">Property in Abu Dhabi</a>
            </li>
            <li><a href="properties/city/Dubai">Property in Dubai</a></li>
            <li><a href="properties/city/Sharjah">Property in Shrjah</a></li>
            <li><a href="properties/city/Ajman">Property in Ajman</a></li>
            <li>
              <a href="properties/city/Umm Al Quwain"
                >Property in Umm AI Quwain</a
              >
            </li>
            <li>
              <a href="properties/city/Ras Al Khaimah"
                >Property in Ras AI Khaimah</a
              >
            </li>
            <li><a href="properties/city/Fujairah">Property in Fujairah</a></li>
          </ul>
        </div>
      </div>

      <div class="col-md-6 col-lg-3">
        <div class="ftco-footer-widget mb-4">
          <h2 class="ftco-heading-2 footer-heading">Connect with Us</h2>
          <div class="contact-info">
            <p class="contact-item">
              <span class="text"
                >Direkt FZCO, Building A1, Dubai Digital Park, Silicon Oasis,
                Dubai, UAE.</span
              >
            </p>
            <p class="contact-item">
              <span class="fa fa-envelope contact-icon"></span>
              <a class="text" href="mailto:customercare@direkt.ae"
                >customercare@direkt.aen</a
              >
            </p>
          </div>

          <h2 class="ftco-heading-2 footer-heading social-title">
            Follow us on
          </h2>
          <ul class="list-unstyled social-icons">
            <!-- <li>
              <a target="_blank" href="#"
                ><span class="fab fa-facebook-f"></span
              ></a>
            </li> -->
            <li>
              <a target="_blank" href="https://www.instagram.com/direktuae/"
                ><span class="fab fa-instagram"></span
              ></a>
            </li>
            <li>
              <a target="_blank" href="https://www.linkedin.com/company/direkt-uae/"
                ><span class="fab fa-linkedin-in"></span
              ></a>
            </li>
            <!-- <li>
              <a target="_blank" href="#"
                ><span class="fab fa-twitter"></span
              ></a>
            </li> -->
            <li>
              <a target="_blank" href="https://www.youtube.com/@DirektAE"
                ><span class="fab fa-youtube"></span
              ></a>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <div class="container-fluid px-0 py-3 bg-dark-copyright">
    <div class="container-xl">
      <div class="row">
        <div class="col-md-12 text-center copyright-text">
          <p
            class="mb-0"
            style="color: rgba(255, 255, 255, 0.5); font-size: 13px"
          >
            Copyright &copy;
            <script>
              document.write(new Date().getFullYear());
            </script>
            All rights reserved | by
            <a href="" target="_blank" rel="nofollow noopener">Direkt</a>
            <a href="/terms-of-use" class="bottom-link ms-2"
              >Terms & Conditions</a
            >
            and
            <a href="privacy-policy" class="bottom-link">Privacy Policy</a>
          </p>
        </div>
      </div>
    </div>
  </div>
</footer>
